import { memo, ReactElement } from 'react';

import Chip from '../Chip';
import classes from './media-card.module.scss';

interface IMediaCardProps {
  image: string;
  title: string | ReactElement;
  description: string | ReactElement;
  chipText: string;
  color: string;
  link?: string;
}

function MediaCard({
  title,
  description,
  image,
  chipText,
  color,
  link,
}: IMediaCardProps) {
  return (
    <a href={link} target="_blank" rel="noreferrer">
      <div className={classes.card}>
        <img src={image} alt="" />
        <div className={classes.content}>
          <h4 className={classes.title}>{title}</h4>
          <p className={classes.description}>{description}</p>
        </div>
        <div className={classes.chip}>
          <Chip textColor="#1D1D1D" title={chipText} color={color} />
        </div>
      </div>
    </a>
  );
}

export default memo(MediaCard);
